const initChatWidget = () => {
  const widget = document.getElementById('customChatWidgetBtn');
  if (!widget || widget.dataset.chatWidgetInitialized === 'true') return;
  
  widget.dataset.chatWidgetInitialized = 'true';

  const pageType = window.shopifyPageType || 'page';

  if (['product', 'collection', 'search', '404', 'cart'].includes(pageType)) {
    widget.classList.add('hidden', 'opacity-0', 'invisible');
    widget.style.pointerEvents = 'none';
    return;
  }

  let isDrawerOpen = false;
  let isFooterVisible = false;
  let isWidgetVisible = null;

  const updateVisibility = () => {
    const shouldHide = isDrawerOpen || isFooterVisible;

    if (isWidgetVisible === !shouldHide) return;
    isWidgetVisible = !shouldHide;

    widget.classList.remove('hidden', 'opacity-0', 'invisible');

    if (!shouldHide) {
      widget.style.pointerEvents = 'auto';
      if (typeof Motion !== 'undefined') {
        Motion.animate(widget, { opacity: 1, visibility: 'visible', transform: ['translateY(15px)', 'translateY(0)'] }, { duration: 0.5, easing: [0.3, 1, 0.3, 1] });
      } else {
        widget.style.transition = 'all var(--animation-primary)';
        widget.style.opacity = '1';
        widget.style.visibility = 'visible';
        widget.style.transform = 'translateY(0)';
      }
    } else {
      widget.style.pointerEvents = 'none';
      if (typeof Motion !== 'undefined') {
        Motion.animate(widget, { opacity: 0, visibility: 'hidden', transform: ['translateY(0)', 'translateY(15px)'] }, { duration: 0.5, easing: [0.3, 1, 0.3, 1] });
      } else {
        widget.style.transition = 'all var(--animation-primary)';
        widget.style.opacity = '0';
        widget.style.visibility = 'hidden';
        widget.style.transform = 'translateY(15px)';
      }
    }
  };

  updateVisibility();

  const bodyObserver = new MutationObserver(() => {
    const drawerState = document.body.classList.contains('has-modal-open') || 
                        document.body.classList.contains('has-modal-opening');
    
    if (isDrawerOpen !== drawerState) {
      isDrawerOpen = drawerState;
      updateVisibility();
    }
  });

  bodyObserver.observe(document.body, { 
    attributes: true, 
    attributeFilter: ['class'] 
  });

  const footer = document.querySelector('.footer, .footer-copyright');
  if (footer && typeof IntersectionObserver !== 'undefined') {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (isFooterVisible !== entry.isIntersecting) {
          isFooterVisible = entry.isIntersecting;
          updateVisibility();
        }
      });
    }, { rootMargin: '0px 0px 40px 0px' });
    observer.observe(footer);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatWidget);
} else {
  initChatWidget();
}